module.exports = __webpack_public_path__ + "img/Step1.73148bc.svg";